import React from 'react';
import './content.css';

/**
 * A simple Content Block component, with a heading and rich text block.
 * This is the most basic building block of a content site, and the most basic
 * JSS component that's useful.
 */
const ContentBlock = (props) => (
  <React.Fragment>
  </React.Fragment>
);

export default ContentBlock;